angular
    .module('MyApp')
    .service('AvaliacaoDescritivaService', ['$resource', '$q', 'SessionData', 'Configs', 'DownloadArquivo', function($resource, $q, SessionData, Configs, DownloadArquivo) {
      var _msgErro = {msgErro: 'Error student undefined'};
    	var aluno;
    	function dadosValidosAluno(){
    		if(SessionData.aluno){
    			aluno = {codPessoa: SessionData.user.id, codAluno: encodeURIComponent(SessionData.aluno.list[SessionData.aluno.selecionado].codAluno)};
    			return true;
    		}
    		return false;
    	}

      this.buscarDisciplinasETurmas = function(codAluno){
        let deferr = $q.defer();
         if (codAluno) {
            $resource(Configs.getApiServer() + '/matricula/turmas-avaliacao-descritiva?cod-aluno=:codAluno',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  codAluno
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }


      this.buscarAvaliacoes = function(codAluno, disciplina, turma){
        let deferr = $q.defer();
         if (codAluno && disciplina && turma) {
            $resource(Configs.getApiServer() + '/matricula/avaliacao-descritiva?cod-aluno=:codAluno&cod-disciplina=:disciplina&cod-turma=:turma',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  codAluno, disciplina, turma
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.downloadAnexoAvalDesc = function(aluno, chave) {
        if (dadosValidosAluno()) {
          let params = {};
          params.url = Configs.getApiServer() + '/matricula/downloadAnexoAvaliacaoDescritiva/aluno/' + aluno + '/chave/' + chave;
          params.method = "GET";

          DownloadArquivo.downloadArquivo(params);
        }
      }

    }]);
